module.exports = __webpack_public_path__ + "static/media/CAMRA-Emerald-Green-top-2019.9de781e3.png";